import * as React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faCheck } from '@fortawesome/free-solid-svg-icons';

interface Props {
  schoolName: string;
  roleLabel: string;
  title: string;
  lines: React.ReactNode[];
  onConfirm: () => void;
  onBack: () => void;
  confirmLabel?: string;
}

export function RegistrationRequestConfirmation(props: Props) {
  return (
    <div className="eRegistrationRequestReview">
      <div className="eSchoolSignupScreenHeader">
        <h1>{props.title}</h1>
        <p>Review the details below before the request is sent.</p>
      </div>

      <section className="eRegistrationRequestPanel">
        <header>
          <div>
            <span>School</span>
            <strong>{props.schoolName}</strong>
          </div>
          <span className="eRegistrationRequestRole">{props.roleLabel}</span>
        </header>

        <div className="eRegistrationRequestBody">
          <div className="eRegistrationRequestLines">
            {props.lines.map((line, index) => (
              <div key={index} className="eRegistrationRequestLine">
                <span aria-hidden="true">
                  <FontAwesomeIcon icon={faCheck} />
                </span>
                <div>{line}</div>
              </div>
            ))}
          </div>

          <div className="eRegistrationRequestActions">
            <button type="button" className="btn btn-primary" onClick={props.onConfirm}>
              {props.confirmLabel || 'Send request'} <FontAwesomeIcon icon={faArrowRight} />
            </button>
            <button type="button" className="btn btn-secondary" onClick={props.onBack}>
              Back
            </button>
          </div>
        </div>
      </section>
    </div>
  );
}
